import { type HolisticCategory } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';
import { type AccountSummary } from '../types/HolisticSummary';

interface UseUpdateSpinwheelCreditCardAccountBody {
    id?: string;
    displayName?: string;
    userId?: string;
    holisticCategory?: HolisticCategory;
    accountRating?: string | null;
    minimumPaymentAmountCents?: number;
    interestRate?: number | null;
    description?: string;
}

const useUpdateSpinwheelCreditCardAccount = requestBuilder.mutation<
    AccountSummary,
    UseUpdateSpinwheelCreditCardAccountBody
>({
    endpoint: () => '/api/spinwheel/liabilities/credit-card',
    method: 'PATCH',
});

export default useUpdateSpinwheelCreditCardAccount;
